// extracted by mini-css-extract-plugin
export default {"cell":"nZ","chance":"na nZ","difficulty":"nb nZ","type":"nc nZ","drop":"nd","name":"ne","wrapper":"nf"};